module.exports = "$(document).on('turbolinks:load',function(){});"